import React from "react";

// Compact single-line stat: icon + label on the left, value on the right.
const StatCard = ({ icon: Icon, label, value, unit, isFlagged = false }) => {
  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-[#F3F4F6] bg-white px-4 py-3">
      <div className="flex min-w-0 items-center gap-2.5">
        {Icon && (
          <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-[#F3F4F6]">
            <Icon size={15} className="text-[#6B7280]" />
          </div>
        )}
        <span className="truncate text-[13px] text-[#6B7280]">{label}</span>
      </div>

      <div className="flex items-baseline gap-0.5">
        <span
          className={`text-2xl font-bold leading-none ${
            isFlagged ? "text-[#E07A3A]" : "text-[#111827]"
          }`}
        >
          {value}
        </span>
        {unit && (
          <span className="text-sm font-medium text-[#9CA3AF]">{unit}</span>
        )}
      </div>
    </div>
  );
};

export default StatCard;
